/** External */
import { gql } from "lib/apolloClient";

export const courseDetailsFragment = gql`
  fragment courseDetails on Course {
    id
    title
    grades {
      id
      name
    }
  }
`;
